import App from "./app";
import Home from "./pages/home";
import SignIn from "./pages/sign-in";
import Download from "./pages/download";
import TermsAndConditions from "./pages/termsAndConditions";
import PrivacyPolicy from "./pages/privacyPolicy";
import Admin from "./pages/admin";
import Affiliate from "./pages/affiliate";
import HitDelayFixMod from "./pages/hitdelayfixmod";
import A from "./pages/a";
import NotFound from "./pages/not-found";
import KohiClickTest from "./pages/kohi-click-test";
import AboutUs from "./pages/about-us";
import ContactUs from "./pages/contact-us";
import Reviews from "./pages/reviews";
import Checkout from "./pages/checkout";
import CycloneCheckout from "./pages/cycloneCheckout";
import PaymentSuccessful from "./pages/paymentSuccessful";
import Key from "./pages/key";
import Instructions from "./pages/instructions";
import Images from "./pages/images";
import Articles from "./pages/articles";

export const paths = {
  ROOT: "/",
  HOME: "/",
  CHECKOUT: "/checkout",
  CYCLONECHECKOUT: "cyclone/checkout",
  PAYMENT_SUCCESSFUL: "/payment-successful",
  DOWNLOAD: "/download",
  KOHI_CLICK_TEST: "/kohi-click-test",
  HITDELAYFIXMOD: "/hitdelayfixmod",
  ARTICLES: "/articles",
  ABOUT_US: "/about-us",
  CONTACT_US: "/contact-us",
  REVIEWS: "/reviews",
  TERMS: "/terms-and-conditions-of-use",
  PRIVACY: "/privacy-policy",
  ADMIN: "/admin",
  AFFILIATE: "/affiliate",
  KEY: "/key",
  INSTRUCTIONS: "/instructions",
  IMAGES: "/images",
  A: "/a/:aid",
  NOT_FOUND: "/*",
};

// const requireAuth = getState => {
//   return (nextState, replace) => {
//     if (!isAuthenticated(getState())) {
//       replace(paths.SIGN_IN);
//     }
//   };
// };

// const requireUnauth = getState => {
//   return (nextState, replace) => {
//     if (isAuthenticated(getState())) {
//       replace(paths.HOME);
//     }
//   };
// };

export const getRoutes = (getState) => {
  return {
    path: paths.ROOT,
    component: App,
    childRoutes: [
      {
        indexRoute: {
          component: Home,
        },
      },
      {
        path: paths.SIGN_IN,
        component: SignIn,
      },
      {
        path: paths.CHECKOUT,
        component: Checkout,
      },
      {
        path: paths.CYCLONECHECKOUT,
        component: CycloneCheckout,
      },
      {
        path: paths.PAYMENT_SUCCESSFUL,
        component: PaymentSuccessful,
      },
      {
        path: paths.DOWNLOAD,
        component: Download,
      },
      {
        path: paths.ABOUT_US,
        component: AboutUs,
      },
      {
        path: paths.CONTACT_US,
        component: ContactUs,
      },
      {
        path: paths.REVIEWS,
        component: Reviews,
      },
      {
        path: paths.ARTICLES,
        component: Articles,
      },
      {
        path: paths.HITDELAYFIXMOD,
        component: HitDelayFixMod,
      },
      {
        path: paths.KOHI_CLICK_TEST,
        component: KohiClickTest,
      },
      {
        path: paths.TERMS,
        component: TermsAndConditions,
      },
      {
        path: paths.PRIVACY,
        component: PrivacyPolicy,
      },
      {
        path: paths.ADMIN,
        component: Admin,
      },
      {
        path: paths.AFFILIATE,
        component: Affiliate,
      },
      {
        path: paths.KEY,
        component: Key,
      },
      {
        path: paths.INSTRUCTIONS,
        component: Instructions,
      },
      {
        path: paths.IMAGES,
        component: Images,
      },
      {
        path: paths.A,
        component: A,
      },
      {
        path: paths.NOT_FOUND,
        component: NotFound,
      },
    ],
  };
};



/** WEBPACK FOOTER **
 ** ./src/views/routes.js
 **/